module.exports = __webpack_public_path__ + "static/media/title.9f6f87ae.png";